/**
 * Stores the active organization id for outbound API requests (Axios + fetch).
 * The backend accepts per-request org switching via X-Organization-Id / X-Org-Id.
 * Synced from AuthContext whenever `organization.id` changes.
 */
const STORAGE_KEY = 'cmndf_active_org_id';

let memoryOrgId: string | null = null;

export function syncRequestOrganizationId(organizationId: string | null): void {
  memoryOrgId = organizationId;
  if (typeof window === 'undefined') return;
  if (organizationId) {
    try {
      sessionStorage.setItem(STORAGE_KEY, organizationId);
    } catch {
      /* ignore quota */
    }
  } else {
    sessionStorage.removeItem(STORAGE_KEY);
  }
}

export function getRequestOrganizationId(): string | null {
  if (memoryOrgId) return memoryOrgId;
  if (typeof window === 'undefined') return null;
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}
